export const MAX_SCHEMA_PROPERTY_LEVEL = 2
